/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react'
import 'antd/dist/antd.css'
import { useDispatch } from 'react-redux'
import { connect } from 'react-redux'
import { Menu, Input, Breadcrumb, Radio, Layout, Carousel, Row, Col, Divider, Spin, Pagination } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import MarketCard from 'components/MarketCard'
import { storageData, clearstorageData } from 'redux/storage'
import { useTranslation } from 'react-i18next'
import { guestGetService, getChoiceService, ChangePassword } from 'api/hub'
import { history } from 'redux/store'
import PageHeader from "components/PageHeader";
import MyFooter from "components/MyFooter";
import Swapcard from 'components/Swapcard'

const { Header, Sider, Content } = Layout;

const Market = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  // Basic Setting
  const dispatch = useDispatch()
  // i18n language switch
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)
  // Search Component
  const { Search } = Input
  const [page, setPage]=useState(1)
  const [pageSize, setPageSize]=useState(5)

  // Get Subscription List
  const [ServiceList, setServiceList] = useState([])
  // const convert = (data) =>{
  //   return {
  //     "page":data.page,
  //     "page_cnt":data.page_cnt,
  //     "service_id":data.overview_data[0].service_id,
  //     "icon_url":data.icon_url,
  //     "service_name_en":data.service_info_data_en[0].service_name,
  //     "service_name_tw":data.service_info_data_tw[0].service_name,
  //     "vendor_name_en":data.vendor_name_en,
  //     "vendor_name_tw":data.vendor_name_tw,
  //     "service_type_en":data.service_type_en,
  //     "service_type_tw":data.service_type_tw,
  //     "summary_en":data.service_info_data_en[0].summary,
  //     "summary_tw":data.service_info_data_tw[0].summary,
  //  }
  // }
  const [ServiceListA, setServiceListA] = useState([])
  const [ServiceListB, setServiceListB] = useState([])
  const [ServiceListC, setServiceListC] = useState([])
  const url = new URL(window.location.href)
  const searchValue = url.searchParams.get("search")?url.searchParams.get("search"):""

  useEffect(()=>{
    dispatch(getChoiceService()).then(
      res => {
        setServiceListA(res.data[0].services)
        setServiceListB(res.data[1].services)
        setServiceListC(res.data[2].services)
      }
    )
    },[])
    const onChange = e => {
      console.log(e);
    }
    // Search
    const handleSearch = value => {
      setLoading(true)
      value?history.push(`/market/list/?search=${value}`):history.push('/market/list/?search=')
      dispatch(guestGetService(
        {
          "keyword": value,
          "page_record_set": 1000,
        }
      ))
      .then(
        res => { 
          if(Object.keys(res).length > 2){
            setServiceList(() => res.data.services) 
            setLoading(false)
          } else {
            setServiceList(() => []) 
            setLoading(false)
          }
         }
        )
    }
    const onShowSizeChange = (current, pageSize) => {
      console.log(current, pageSize);
      setPageSize(pageSize)
    };
    const onPageChange = (current) =>{
      console.log(current)
      setPage(current)
    }
    const currentTableData = useMemo(() => {
      const firstPageIndex = (page - 1) * pageSize;
      const lastPageIndex = firstPageIndex + pageSize;
      return ServiceList.slice(firstPageIndex, lastPageIndex);
    }, [page, pageSize, ServiceList]);

  return (
      <Layout>
        <Header>
         <PageHeader/>
        </Header>
        <Spin tip={t('Global.Loading')} spinning={loading} style={{padding: '36px 0 0 130px'}}>
          <Content style={{ height: '95vh' }}>
          <a href='https://www.wiadvance.com/solutions-article/marketplace/' target="_blank">
            <Carousel afterChange={onChange}>
              <div className="mobilebanner" style={{
                height: '300px',
                color: '#fff',
                lineHeight: '160px',
                textAlign: 'center',
                background: '#7DB926',
                zIndex: '100',
                position: 'relative'
              }}>
                <img src={localStorage.getItem('lang') === "en" ? '/Mobile_English.svg' : '/Mobile_Chinese.svg'}
                // {/* <img src="/newBackgroundImage.png" */}
                  style={{
                    paddingTop:'20px',
                    height: '300px',
                    margin: 'auto',
                    width: "100%",
                    display: 'block',
                    maxWidth: '1920px',
                    objectFit: 'cover'
                  }} alt="banner" />

              </div>
            </Carousel>
            </a>
            <a href='https://www.wiadvance.com/solutions-article/marketplace/' target="_blank">
            <Carousel afterChange={onChange}>
              <div className="pcbanner" style={{
                height: '300px',
                color: '#fff',
                lineHeight: '160px',
                textAlign: 'center',
                background: '#7DB926',
                zIndex: '100',
                position: 'relative'
              }}>
                <img src={localStorage.getItem('lang') === "en" ? '/Horizontal_English.svg' : '/Horizontal_Chinese.svg'}
                  style={{
                    paddingTop: '20px',
                    height: '300px',
                    margin: 'auto',
                    width: "100%",
                    display: 'block',
                    maxWidth: '1920px',
                    objectFit: 'cover'
                  }} alt="banner" />
              </div>
              
            </Carousel>
            </a>

            <div className='innerlayout' style={{ maxWidth: '1280px', padding: '25px 0px', width: '100%', minHeight: '1400px', margin: 'auto' }}>


              <div className='searchbar' style={{ width: '100%', marginTop: '0px' }}>
                <div className='mid'>
                  <Search
                    onSearch={handleSearch}
                    enterButton={t('Subscription.search')}
                    defaultValue={searchValue}
                    allowClear
                    size="large"
                    placeholder={t('Global.searchServices')}
                    prefix={<SearchOutlined className="site-form-item-icon" />} />
                </div>
              </div>
              <div style={{ fontSize: "28px", margin: "28px" }}>{t('Global.Choice')}</div>
              <div style={{ height: "400px" }}>
                <Swapcard data={ServiceListA}/>
              </div>
              <div style={{ fontSize: "28px", margin: "28px" }}>{t('Global.New')}</div>
              <div style={{ height: "400px" }}>
                <Swapcard data={ServiceListB}/>
              </div>
              <div style={{ fontSize: "28px", margin: "28px" }}>{t('Global.Hot')}</div>
              <div style={{ height: "400px" }}>
                <Swapcard data={ServiceListC}/>
              </div>
            </div>
            <MyFooter />


          </Content>
        </Spin>

      </Layout>

  )
}
// 將store中的items值傳綁到props上
const mapStateToProps = store => (
  { storeData: store.storeData }
)
const mapDispatchToProps = dispatch => {
  return {
    storageData: (payload) => {
      dispatch(storageData(payload))
    },
    clearstorageData: () => {
      dispatch(clearstorageData())
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Market)